module.exports = __webpack_public_path__ + "static/media/CompassionateLeave.2eaec32c.svg";